import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './Button.module.scss'
// components
import Sunny from '../images/svg/icon_sunny.svg'
import ArrowRight from '../images/svg/icon_arrow-right.svg'

const Button = ({ title, link, type, className }) => {
    switch(type) {
        case 'external':
            return (
                <a 
                    className={`${styles.wrapper} ${className}`}
                    href={link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    <span>{title}</span>
                    <div className={styles.icon}>
                        <Sunny />
                        <ArrowRight />
                    </div>
                </a>
            );
        case 'link':
            return (
                <Link 
                    className={`${styles.wrapper} ${className}`}
                    to={link}
                >
                    <span>{title}</span>
                    <div className={styles.icon}>
                        <Sunny />
                        <ArrowRight />
                    </div>
                </Link>
            );
        case 'scroll':
            return (
                <a
                    className={`${styles.wrapper} ${className}`}
                    onClick={() => utils.moveto(link)}
                >
                    <span>{title}</span>
                    <div className={styles.icon}>
                        <Sunny />
                        <ArrowRight />
                    </div>
                </a>
            )
        case 'mailto':
            return (
                <a 
                    className={`${styles.wrapper} ${className}`}
                    href={`mailto:${link}`} 
                >
                    <span>{title}</span>
                    <div className={styles.icon}>
                        <Sunny />
                        <ArrowRight />
                    </div>
                </a>
            );
        default:
            return null;
    }
}

Button.propTypes = {
    title: PropTypes.string,
    link: PropTypes.string,
    type: PropTypes.string,
}

Button.defaultProps = {
    title: `View More`,
    link: `/`,
    type: `link`,
}

export default Button
